/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { colors, gridSize } from '@atlaskit/theme';

const backgroundColor = colors.N0;

export const LoadMoreActivityWrapper = styled.div`
  padding-bottom: ${gridSize() / 2}px;
  padding-top: ${gridSize()}px;
  text-align: center;
`;

export const Spinner = styled.div`
  text-align: center;
`;

export const EmptyState = styled.p`
  padding: ${1.75 * gridSize()}px;
  width: ${25 * gridSize()}px;
  margin: 0 auto;
  text-align: center;
`;

// COREX-2972: Modifying the border-radius from ADG's 3px to 4px for each card in activities
export const activityEntryCard = styled.div`
  background-color: ${backgroundColor};
  border-radius: 4px;
  box-shadow: 0 1px 1px ${colors.N50A}, 0 0 1px ${colors.N60A};
  margin-top: ${gridSize()}px;
  padding: ${gridSize()}px;
  text-align: left;
`;
